var _defs, _rect, _g, _text, _text2, _text3, _g2, _text4, _rect2, _text5, _text6, _rect3, _text7, _text8, _rect4, _text9, _text10, _rect5, _text11, _text12, _g3, _text13, _rect6, _text14, _text15, _line, _circle, _text16, _text17, _g4, _text18, _text19, _rect7, _text20, _rect8, _text21, _g5, _text22, _text23, _rect9, _text24, _rect10, _text25, _text26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchitectureVpc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 560",
    fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glowBlue",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 4.5,
    floodColor: "#3b82f6",
    floodOpacity: 0.55
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glowSlate",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 3.5,
    floodColor: "#64748b",
    floodOpacity: 0.35
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-cube",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2 21 7 21 17 12 22 3 17 3 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7 12 12 21 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12 12 22"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "i-layers",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3 21 8 12 13 3 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12 12 17 21 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16 12 21 21 16"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "i-db",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 8,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v12a8 3 0 0 0 16 0V6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12a8 3 0 0 0 16 0"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "i-lock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 14,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11V7a4 4 0 0 1 8 0v4"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "i-server",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 7,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 18,
    height: 7,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5h.01M7 16.5h.01"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "i-ban",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 5.6 18.4 18.4"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 560,
    fill: "#0a0f1e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1b2942",
    fill: "none",
    strokeWidth: 1,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 815,
    cy: 70,
    rx: 60,
    ry: 42
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 815,
    cy: 70,
    rx: 115,
    ry: 80
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 815,
    cy: 70,
    rx: 175,
    ry: 122
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 815,
    cy: 70,
    rx: 240,
    ry: 168
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 520,
    rx: 70,
    ry: 46
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 520,
    rx: 135,
    ry: 88
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 520,
    rx: 205,
    ry: 134
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 40,
    fontSize: 15,
    fontWeight: 700,
    fill: "#e6edfb"
  }, "Mermadic Infrastructure on AWS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 60,
    fontSize: 12,
    fill: "#7e8db0"
  }, "Isolation begins at the network layer. Every account gets its own private VPC.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 92,
    fontFamily: "'JetBrains Mono','SFMono-Regular',Consolas,monospace",
    fontSize: 10.5,
    letterSpacing: 2,
    fill: "#5f79b0"
  }, "YOUR ACCOUNT / PRIVATE VPC 10.X.0.0/16")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glowBlue)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 102,
    width: 556,
    height: 300,
    rx: 16,
    fill: "#0d1730",
    stroke: "#3b82f6",
    strokeWidth: 1.6,
    strokeDasharray: "7 6"
  }))), /*#__PURE__*/React.createElement("use", {
    href: "#i-server",
    x: 64,
    y: 122,
    width: 18,
    height: 18,
    style: {
      color: "#60a5fa"
    }
  }), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 136,
    fontFamily: "'JetBrains Mono','SFMono-Regular',Consolas,monospace",
    fontSize: 10.5,
    letterSpacing: 1.5,
    fill: "#93b4ef"
  }, "DEDICATED EKS CLUSTER")), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 150,
    width: 164,
    height: 54,
    rx: 10,
    fill: "#101c36",
    stroke: "#28375a"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-cube",
    x: 80,
    y: 169,
    width: 18,
    height: 18,
    style: {
      color: "#60a5fa"
    }
  }), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 174,
    fontSize: 12,
    fontWeight: 600,
    fill: "#dbe4f7"
  }, "Your pods")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 190,
    fontSize: 10.5,
    fill: "#8593b8"
  }, "jobs &amp; deployments")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 150,
    width: 176,
    height: 54,
    rx: 10,
    fill: "#101c36",
    stroke: "#28375a"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-layers",
    x: 256,
    y: 169,
    width: 18,
    height: 18,
    style: {
      color: "#c084fc"
    }
  }), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 282,
    y: 174,
    fontSize: 12,
    fontWeight: 600,
    fill: "#dbe4f7"
  }, "Private registry")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 282,
    y: 190,
    fontSize: 10.5,
    fill: "#8593b8"
  }, "image pull secret")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 428,
    y: 150,
    width: 148,
    height: 54,
    rx: 10,
    fill: "#101c36",
    stroke: "#28375a"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-db",
    x: 444,
    y: 169,
    width: 18,
    height: 18,
    style: {
      color: "#34d399"
    }
  }), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 174,
    fontSize: 12,
    fontWeight: 600,
    fill: "#dbe4f7"
  }, "Your data")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 190,
    fontSize: 10.5,
    fill: "#8593b8"
  }, "&amp; your secrets"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 216,
    width: 512,
    height: 50,
    rx: 10,
    fill: "#0e1c17",
    stroke: "#1f4d38"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-lock",
    x: 80,
    y: 232,
    width: 18,
    height: 18,
    style: {
      color: "#4ade80"
    }
  }), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 236,
    fontSize: 12,
    fontWeight: 600,
    fill: "#d5e6dd"
  }, "Dedicated API endpoint")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 252,
    fontSize: 10.5,
    fill: "#7fae95"
  }, "https://&lt;cluster&gt;-job.mermadicrunner.com")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(500,229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 24,
    rx: 12,
    fill: "#123524",
    stroke: "#22c55e",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 16,
    fontSize: 11,
    fontWeight: 700,
    fill: "#4ade80",
    textAnchor: "middle"
  }, "TLS"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 290,
    fontSize: 11,
    fill: "#7e8db0"
  }, "Auto-scaling nodes / load balancer / monitoring, fully managed by Mermadic")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 304,
    width: 512,
    height: 72,
    rx: 10,
    fill: "#0b1425",
    stroke: "#26324f",
    strokeDasharray: "4 4"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 332,
    fontSize: 12,
    fontWeight: 600,
    fill: "#cdd8ef"
  }, "Up to 16 clusters per VPC")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 352,
    fontSize: 10.5,
    fill: "#8593b8"
  }, "All your Gold &amp; Premium clusters share this VPC for fast, private internal traffic.")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 612,
    y1: 112,
    x2: 612,
    y2: 392,
    stroke: "#2b3a5c",
    strokeWidth: 1.5,
    strokeDasharray: "6 6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(612,252)",
    filter: "url(#glowSlate)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 22,
    fill: "#0d1730",
    stroke: "#64748b",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("use", {
    href: "#i-ban",
    x: -11,
    y: -11,
    width: 22,
    height: 22,
    style: {
      color: "#94a3b8"
    }
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 612,
    y: 392,
    fontFamily: "'JetBrains Mono','SFMono-Regular',Consolas,monospace",
    fontSize: 9.5,
    letterSpacing: 1.5,
    fill: "#64748b",
    textAnchor: "middle",
    transform: "rotate(90 612 392)"
  }, "NO CROSS-TENANT NETWORK PATHS")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 92,
    fontFamily: "'JetBrains Mono','SFMono-Regular',Consolas,monospace",
    fontSize: 10.5,
    letterSpacing: 2,
    fill: "#566079"
  }, "OTHER ACCOUNTS / SEPARATE VPCS")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glowSlate)",
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 102,
    width: 280,
    height: 132,
    rx: 14,
    fill: "#0c1322",
    stroke: "#3a465f",
    strokeWidth: 1.4,
    strokeDasharray: "7 6"
  }))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 662,
    y: 130,
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#9aa7c4"
  }, "Customer B")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 900,
    y: 130,
    fontSize: 10.5,
    fontFamily: "'JetBrains Mono',Consolas,monospace",
    fill: "#5f6f92",
    textAnchor: "end"
  }, "10.Y.0.0/16")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 662,
    y: 146,
    width: 236,
    height: 30,
    rx: 7,
    fill: "#101827",
    stroke: "#2a3552"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 676,
    y: 165,
    fontSize: 10.5,
    fill: "#7e8aa8"
  }, "Separate cluster / separate subnets")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 662,
    y: 184,
    width: 236,
    height: 30,
    rx: 7,
    fill: "#101827",
    stroke: "#2a3552"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 676,
    y: 203,
    fontSize: 10.5,
    fill: "#7e8aa8"
  }, "Unreachable from your account")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glowSlate)",
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 250,
    width: 280,
    height: 132,
    rx: 14,
    fill: "#0c1322",
    stroke: "#3a465f",
    strokeWidth: 1.4,
    strokeDasharray: "7 6"
  }))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 662,
    y: 278,
    fontSize: 12.5,
    fontWeight: 700,
    fill: "#9aa7c4"
  }, "Customer C")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 900,
    y: 278,
    fontSize: 10.5,
    fontFamily: "'JetBrains Mono',Consolas,monospace",
    fill: "#5f6f92",
    textAnchor: "end"
  }, "10.Z.0.0/16")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 662,
    y: 294,
    width: 236,
    height: 30,
    rx: 7,
    fill: "#101827",
    stroke: "#2a3552"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 676,
    y: 313,
    fontSize: 10.5,
    fill: "#7e8aa8"
  }, "Separate cluster / separate subnets")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 662,
    y: 332,
    width: 236,
    height: 30,
    rx: 7,
    fill: "#101827",
    stroke: "#2a3552"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 676,
    y: 351,
    fontSize: 10.5,
    fill: "#7e8aa8"
  }, "Unreachable from your account")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 410,
    fontSize: 11,
    fill: "#566079"
  }, "Each account is fully isolated in its own private VPC.")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitectureVpc);
export default __webpack_public_path__ + "static/media/architecture-vpc.a6cb464c4d16ea915c662b39ca431d66.svg";
export { ForwardRef as ReactComponent };